import { defineMessage } from 'services/localization';

export const messages = {
    title: defineMessage('purchase_order_matching'),
    manualMatchiungSubtitle: defineMessage('enable_the_manual_matching_to_purchase_orders'),
    billApproveSubtitle: defineMessage('can_a_bill_be_approved__hed_to_a_purchase_order'),
    optionAllowToMatch: defineMessage('allow_users_to_match_bi_o_purchase_orders_lines'),
    optionYes: defineMessage('yes_unmatched_bills_can_be_approved'),
    optionNoAtLeastOne: defineMessage('no_at_least_one_line_sh_hed_to_a_purchase_order'),
    optionNoEachLine: defineMessage('no_each_line_should_be_matched_to_a_purchase_order'),
};
